import { TextFieldProps } from '@mui/material'
import { Control, Controller, FieldValues } from 'react-hook-form'
import 'react-international-phone/style.css'
import { MuiPhone } from './muiPhone'

type SmartInputProps = {
  control?: Control<FieldValues, object>
  register?: unknown
  name: string
  label: string
  onPhoneChange?: (phone: string) => void
  rest?: any
} & Omit<TextFieldProps, 'onChange'>

export default function MuiPhoneForm(props: SmartInputProps) {
  const { control, register, name, label, onPhoneChange, ...rest } = props
  void register // strip renderer-injected register from rest

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <MuiPhone
            value={value}
            onChange={onChange}
            onPhoneChange={onPhoneChange}
            label={label}
            error={Boolean(error?.message)}
            helperText={error?.message ? error.message : rest.helperText}
            sx={{ flexGrow: '1' }}
            {...rest}
          />
        )}
      />
    </div>
  )
}
